//REGISTER
export const GET_WAREHOUSE_LIST = "/warehouses";
export const InventoryPath = "/product";
export const StockPath = "/stock";
export const clientPath = "/customers"